import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [props: string]: any
}

export const PauseIcon = ({ sx, ...props }: Props) => (
  <SvgIcon viewBox="0 0 24 24" sx={{ color: 'white', ...sx }} {...props}>
    <path
      d="M5 18.0129C5 19.2024 5.96431 20.1667 7.15385 20.1667H7.51282C8.70236 20.1667 9.66667 19.2024 9.66667 18.0129V5.98722C9.66667 4.79768 8.70236 3.83337 7.51282 3.83337H7.15385C5.96431 3.83337 5 4.79768 5 5.98722V18.0129ZM16.4872 3.83337C15.2976 3.83337 14.3333 4.79768 14.3333 5.98722V18.0129C14.3333 19.2024 15.2976 20.1667 16.4872 20.1667H16.8462C18.0357 20.1667 19 19.2024 19 18.0129V5.98722C19 4.79768 18.0357 3.83337 16.8462 3.83337H16.4872Z"
      fill="inherit"
    />
  </SvgIcon>
)

PauseIcon.defaultProps = {
  sx: null,
}
